import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconShoppingBag2"><Path fillRule="evenodd" clipRule="evenodd" d="M7.99915 6C7.99915 3.79086 9.79001 2 11.9991 2C14.2083 2 15.9991 3.79086 15.9991 6V7H16.2645C17.5087 7 18.5635 7.91482 18.7394 9.14645L20.168 19.1464C20.3831 20.6525 19.2145 22 17.6931 22H6.30516C4.78378 22 3.61513 20.6525 3.83028 19.1464L5.25886 9.14644C5.4348 7.91482 6.4896 7 7.73373 7H7.99915V6ZM8.99915 7H14.9991V6C14.9991 4.34315 13.656 3 11.9991 3C10.3423 3 8.99915 4.34315 8.99915 6V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag2;
